import moment from "moment";
import { DATE_FORMAT, DATE_TIME_FORMAT, dateTimeFormatter } from "./date";

export const getNoteHeaderLabel = ({ t, updatedByUserName, createdByUserName, updatedAt, createdAt }) => {
  return updatedByUserName
    ? t("edit_notes.updated_by", {
        user: updatedByUserName,
        updatedDate: dateTimeFormatter(moment(updatedAt), DATE_FORMAT)
      })
    : createdByUserName
    ? t("edit_notes.created_by", {
        user: createdByUserName,
        createdDate: dateTimeFormatter(moment(createdAt), DATE_FORMAT)
      })
    : t("edit_notes.created_on", {
        createdDate: dateTimeFormatter(moment(createdAt), DATE_FORMAT)
      });
};

export const getNoteTooltipContent = ({ t, updatedByUserName, createdByUserName, createdAt, updatedAt }) => {
  return updatedByUserName && createdByUserName
    ? t("edit_notes.note_history_tooltip", {
        createdBy: createdByUserName,
        createdDate: dateTimeFormatter(moment(createdAt), DATE_TIME_FORMAT),
        updatedBy: updatedByUserName,
        updatedDate: dateTimeFormatter(moment(updatedAt), DATE_TIME_FORMAT)
      })
    : updatedByUserName && !createdByUserName
    ? t("edit_notes.note_history_tooltip_without_created_by", {
        createdDate: dateTimeFormatter(moment(createdAt), DATE_TIME_FORMAT),
        updatedBy: updatedByUserName,
        updatedDate: dateTimeFormatter(moment(updatedAt), DATE_TIME_FORMAT)
      })
    : createdByUserName
    ? t("edit_notes.note_created_tooltip", {
        createdBy: createdByUserName,
        createdDate: dateTimeFormatter(moment(createdAt), DATE_TIME_FORMAT)
      })
    : t("edit_notes.note_created_tooltip_no_update", {
        createdDate: dateTimeFormatter(moment(createdAt), DATE_TIME_FORMAT)
      });
};

export const formatUserName = (user) => {
  if (!user) return "";
  return user.firstName && user.lastName ? `${user.lastName}, ${user.firstName}` : "";
};
